import { useEffect, useRef } from "react";

import { useRouter } from "next/navigation";

const handleRedirectToProfilePage = ({ target }, push) => {
  const mention = target.parentElement;
  const userName = mention.getAttribute("data-username");
  push(`/user/${userName}`);
};

interface IMentionProps {
  value: string;
  style: object;
  className: string;
}

export const Mention = ({ value, style, className }: IMentionProps) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const { push } = useRouter();

  useEffect(() => {
    if (!spanRef?.current) return;

    const mentionsElements = [
      ...spanRef.current.querySelectorAll('[data-denotation-char="@"]'),
    ];

    if (!mentionsElements.length) return;

    mentionsElements.forEach((mention) => {
      mention.addEventListener("click", (event) =>
        handleRedirectToProfilePage(event, push),
      );
    });

    return () =>
      mentionsElements.forEach((mention) =>
        mention?.removeEventListener("click", (event) =>
          handleRedirectToProfilePage(event, push),
        ),
      );
  }, [spanRef?.current]);

  return (
    <span
      dangerouslySetInnerHTML={{ __html: value }}
      style={{ ...style }}
      className={className}
      ref={spanRef}
    />
  );
};
